"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var _BasicItem = _interopRequireDefault(require("../components/BasicItem"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Basic = function Basic(_ref) {
  var items = _ref.items,
    noNotificationText = _ref.noNotificationText;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--items d8-u-overflow-auto"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid__wrapper"
  }, items.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: JSON.stringify(item)
    }, item.link ? /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      id: item.link.id,
      className: item.link.className,
      href: item.link.url
    }, /*#__PURE__*/_react["default"].createElement(_BasicItem["default"], {
      item: item,
      index: i,
      isLast: i + 1 === items.length,
      noNotificationText: noNotificationText
    })) : /*#__PURE__*/_react["default"].createElement(_BasicItem["default"], {
      item: item,
      index: i,
      isLast: i + 1 === items.length,
      noNotificationText: noNotificationText
    }));
  })));
};
Basic.propTypes = {
  items: _propTypes["default"].array.isRequired,
  noNotificationText: _propTypes["default"].bool
};
var _default = exports["default"] = Basic;